import { Select, MenuItem } from '@material-ui/core';
import React, { Component } from 'react';
import './GasCostCalculator.css';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ImageLogo from '../images/logo.jpg';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import GasButtonStyles from '../components/GasButtonStyles';
import GasInputStyles from '../components/GasInputStyles';
import GasCalculatorStyles from '../components/GasCalculatorStyles';
import GasResultComponent from '../components/GasResultComponent';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

class GasCostCalculator extends Component {

    constructor(props) {
        super(props);
        this.state = {
            gcc_gas_region: [],
            gcc_gas_purpose: [],
            gcc_fuel_name: [],
            gcc_fuel_unit: [],
            gcc_fuel_cost: [],
            gcc_fuel_name_etc: [],
            gcc_fuel_unit_etc: [],
            selected_region: '',
            selected_purpose: '',
            selected_fuel: '',
            selected_unit: '',
            selected_cost: '',
            inputed_price: '',
            inputed_cost: '',
            result_cost: '',
            result_per: ''
        }
        this.stateRefresh = this.stateRefresh.bind(this);
    }
    stateRefresh() {
        this.setState({
            gcc_gas_region: [],
            gcc_gas_purpose: [],
            gcc_fuel_name: [],
            gcc_fuel_unit: [],
            gcc_fuel_cost: [],
            gcc_fuel_name_etc: [],
            gcc_fuel_unit_etc: [],
            selected_region: '',
            selected_purpose: '',
            selected_fuel: '',
            selected_unit: '',
            selected_cost: '',
            inputed_price: '',
            inputed_cost: '',
            result_cost: '',
            result_per: ''
        });
        this.callGasRegion()
            .then(res => this.setState({ gcc_gas_region: res }))
            .catch(err => console.log(err));
        this.callGasPurpose()
            .then(res => this.setState({ gcc_gas_purpose: res }))
            .catch(err => console.log(err));
        this.callFuelValue()
            .then(res => this.setState({ gcc_fuel_name: res }))
            .catch(err => console.log(err));
        this.callFuelValueT()
            .then(res => this.setState({ gcc_fuel_name_etc: res }))
            .catch(err => console.log(err));
        this.callFuelUnit()
            .then(res => this.setState({ gcc_fuel_unit: res }))
            .catch(err => console.log(err));
        this.callFuelUnitT()
            .then(res => this.setState({ gcc_fuel_unit_etc: res }))
            .catch(err => console.log(err));
        this.callCostUnit()
            .then(res => this.setState({ gcc_fuel_cost: res }))
            .catch(err => console.log(err));
    }

    componentDidMount() {
        this.timer = setInterval(this.progress, 100000);//progress 타이머 확인
        this.callGasRegion()
            .then(res => this.setState({ gcc_gas_region: res }))
            .catch(err => console.log(err));
        this.callGasPurpose()
            .then(res => this.setState({ gcc_gas_purpose: res }))
            .catch(err => console.log(err));
        this.callFuelValue()
            .then(res => this.setState({ gcc_fuel_name: res }))
            .catch(err => console.log(err));
        this.callFuelValueT()
            .then(res => this.setState({ gcc_fuel_name_etc: res }))
            .catch(err => console.log(err));
        this.callFuelUnit()
            .then(res => this.setState({ gcc_fuel_unit: res }))
            .catch(err => console.log(err));
        this.callFuelUnitT()
            .then(res => this.setState({ gcc_fuel_unit_etc: res }))
            .catch(err => console.log(err));
        this.callCostUnit()
            .then(res => this.setState({ gcc_fuel_cost: res }))
            .catch(err => console.log(err));
    }

    callGasRegion = async () => {
        const response = await fetch('/api/gcc_gas_region');
        const body = await response.json();
        return body;
    }

    callGasPurpose = async () => {
        const response = await fetch('/api/gcc_gas_purpose');
        const body = await response.json();
        return body;
    }

    callFuelValue = async () => {
        const response = await fetch('/api/gcc_fuel_name');
        const body = await response.json();
        return body;
    }

    callFuelValueT = async () => {
        const response = await fetch('/api/gcc_fuel_name_etc');
        const body = await response.json();
        return body;
    }

    callFuelUnit = async () => {
        const response = await fetch('/api/gcc_fuel_unit');
        const body = await response.json();
        return body;
    }

    callFuelUnitT = async () => {
        const response = await fetch('/api/gcc_fuel_unit_etc');
        const body = await response.json();
        return body;
    }

    callCostUnit = async () => {
        const response = await fetch('/api/gcc_fuel_cost');
        const body = await response.json();
        return body;
    }

    progress = () => {
        const { completed } = this.state;
        this.setState({ completed: completed >= 100 ? 0 : completed + 1 });
    };

    regionChange = event => {
        this.setState({ selected_region: event.target.value, name: event.target.name });
    };

    purposeChange = event => {
        this.callFuelValueT()
        .then(res => this.setState({ gcc_fuel_name_etc: res }))
        .catch(err => console.log(err));
        this.setState({ selected_purpose: event.target.value, name: event.target.name, selected_fuel:'' });
    };

    fuelChange = event => {
        this.callFuelUnitT()
        .then(res => this.setState({ gcc_fuel_unit_etc: res }))
        .catch(err => console.log(err));
        this.setState({ selected_fuel: event.target.value, name: event.target.name, selected_unit:'' });
    };

    unitChange = event => {
        this.setState({ selected_unit: event.target.value, name: event.target.name });
    };

    costChange = event => {
        this.setState({ selected_cost: event.target.value, name: event.target.name });
    };

    priceInput = event => {
        this.setState({ inputed_price: event.target.value });
    };

    costInput = event => {
        this.setState({ inputed_cost: event.target.value });
    };

    regionRender() {
        return this.state.gcc_gas_region.map((dt, i) => {
            return (
                <MenuItem
                    label="Select a region"
                    value={dt.REGION_CD}
                    key={i} name={dt.REGION_NM}>{dt.REGION_NM}
                </MenuItem>
            );
        });
    }

    purposeRender() {
        return this.state.gcc_gas_purpose.map((dt, i) => {
            return (
                <MenuItem
                    label="Select a purpose"
                    value={dt.GAS_CD}
                    key={i} name={dt.GAS_NM}>{dt.GAS_NM}
                </MenuItem>
            );
        });
    }

    usingRender() {
        if(this.state.selected_purpose ==="I" || this.state.selected_purpose ===""){
            return this.state.gcc_fuel_name.map((dt, i) => {
                return (
                    <MenuItem
                    label="Select a using"
                    value={dt.FUEL_NM}
                    key={i} name={dt.FUEL_NM}>{dt.FUEL_NM}
                    </MenuItem>
                );
            });
        }
        else{
            return this.state.gcc_fuel_name_etc.map((dt, i) => {
                return (
                    <MenuItem
                    label="Select a using"
                    value={dt.FUEL_NM}
                    key={i} name={dt.FUEL_NM}>{dt.FUEL_NM}
                    </MenuItem>
                );
            });
        }
    }

    unitRender() {
        if(this.state.selected_fuel ==="LPG" || this.state.selected_fuel ===""){
            return this.state.gcc_fuel_unit.map((dt, i) => {
                return (
                    <MenuItem
                    label="Select a unit"
                    value={dt.FUEL_UNIT}
                    key={i} name={dt.FUEL_UNIT}>{dt.FUEL_UNIT}
                    </MenuItem>
                );
            });
        }
        else{
            return this.state.gcc_fuel_unit_etc.map((dt, i) => {
                return (
                    <MenuItem
                    label="Select a unit"
                    value={dt.FUEL_UNIT}
                    key={i} name={dt.FUEL_UNIT}>{dt.FUEL_UNIT}
                    </MenuItem>
                );
            });
        }
    }

    costRender() {
        return this.state.gcc_fuel_cost.map((dt, i) => {
            return (
                <MenuItem
                    label="Select a cost"
                    value={dt.COST_CD}
                    key={i} name={dt.COST_NM}>{dt.COST_NM}
                </MenuItem>
            );
        });
    }
/*계산하기 기능*/
    onClick  = async () => {
        const region = this.state.selected_region;
        const purpose = this.state.selected_purpose;
        const fuel = this.state.selected_fuel;
        const price = this.state.inputed_price;
        const price_unit = this.state.selected_unit;
        const cost = this.state.inputed_cost;
        const cost_unit = this.state.selected_cost;

        if(region === ""){
            alert("지역을 입력해 주세요.");
            return;
        }
        if(purpose === ""){
            alert("용도를 입력해 주세요.");
            return;
        }
        if(fuel === ""){
            alert("사용 중인 연료를 입력해 주세요.");
            return;
        }
        if(price === ""){
            alert("연료 공급단가를 입력해 주세요.");
            return;
        }
        if(price_unit === ""){
            alert("연료 공급단가 단위를 입력해 주세요.");
            return;
        }
        if(cost === ""){
            alert("에너지 비용을 입력해 주세요.");
            return;
        }
        if(cost_unit === ""){
            alert("에너지 비용 단위를 입력해 주세요.");
            return;
        }
        
        if(isNaN(price) === true){
            alert("연료 공급단가는 숫자만 입력 가능합니다.");
            return;
        }

        if(isNaN(cost) === true){
            alert("에너지 비용은 숫자만 입력 가능합니다.")
            return;
        }
        
        // console.log(this.state.selected_purpose);
        // console.log(this.state.selected_fuel);
        // console.log(this.state.selected_unit);
        // console.log(this.state.selected_cost);
        // console.log(this.state.inputed_price);
        // console.log(this.state.inputed_cost);
        
        const response = await fetch('/api/gcc_gas_result', {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type' : 'application/json'
            },
            body: JSON.stringify({
                region: region,
                purpose: purpose,
                fuel: fuel,
                price: price,
                price_unit: price_unit,
                cost: cost,
                cost_unit: cost_unit
            })
        })

        const body = await response.json();

        body.forEach((dt) => {
            this.setState({ result_cost: dt.SAVE_COST, result_per: dt.SAVE_PER });
        })
        return body;
        // body.map((dt, i) => {
        //     console.log("aaaa"+dt.SAVE_COST);
        //     this.setState({ result_cost: dt.SAVE_COST, result_per: dt.SAVE_PER });
        //     // console.log(this.state.result_cost);
        //     // console.log(this.state.result_per);
        // })
        // return body;
    };


    /* insert api 호출 기능 */
    onClick2  = async () => {

        const response = await fetch('/api/test_insert', {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type' : 'application/json'
            }
        })

        const body = await response.json();

        return body;
    };

    /* insert2 api 호출 기능 */
    onClick3  = async () => {

        const response = await fetch('/api/test_insert2', {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type' : 'application/json'
            }
        })

        const body = await response.json();

        return body;
    };

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                {/* BAR
                <AppBar position="static">
                    <Toolbar>
                        <IconButton className={classes.menuButton} color="inherit" aria-label="Open drawer">
                            <MenuIcon />
                        </IconButton>
                        <Typography className={classes.title} variant="h6" color="inherit" noWrap>
                        </Typography>
                        <div className={classes.grow} />
                    </Toolbar>
                </AppBar> */}
                {/* TOP */}
                <div className="div_logo">
                    <br />
                    <img width='150' src={ImageLogo} alt="대륜이엔에스 로고입니다." />
                    <br /><br />
                </div>
                <Typography variant="h4" align="center" color="textPrimary"  gutterBottom>
                    도시가스 연료전환<br />경제성 계산기
                </Typography>
                <div className="div_sub_title">
                    <p>▼고객님이 사용 중인 연료와 도시가스를 비교해보세요</p>
                </div>
                {/* MIDDLE */}
                <div className={classes.fnTitle}  align="center">
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl}>
                                <InputLabel shrink id="label-gas-region">지역</InputLabel>
                                <Select labelId="gas-region" id="select-gas-region" className="w300" value={this.state.selected_region} onChange={this.regionChange}>
                                    {this.regionRender()}
                                </Select>
                            </FormControl>
                        </Grid>
                        <br />
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl}>
                                <InputLabel shrink id="label-gas-purpose">용도</InputLabel>
                                <Select labelId="gas-purpose" id="select-gas-purpose" className="w300" value={this.state.selected_purpose} onChange={this.purposeChange}>
                                    {this.purposeRender()}
                                </Select>
                            </FormControl>
                        </Grid>
                        <br />
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl}>
                                <InputLabel shrink id="label-gas-using">사용 중인 연료</InputLabel>
                                <Select labelId="gas-using" id="select-gas-using" className="w300" value={this.state.selected_fuel} onChange={this.fuelChange}>
                                    {this.usingRender()}
                                </Select>
                            </FormControl>
                        </Grid>
                        <br />
                        <Grid item xs={12}>
                            <FormControl className={classes.margin}>
                                <InputLabel shrink id="label-gas-price">연료 공급단가(VAT 포함)</InputLabel>
                                <GasInputStyles className="w180" id="input-gas-price" type="number" value={this.state.inputed_price} onChange={this.priceInput}/>
                            </FormControl>
                            <FormControl className={classes.margin}>
                                <InputLabel shrink id="label-gas-price-unit">연료 공급단가 단위</InputLabel>
                                <Select labelId="gas-price-unit" id="select-gas-price-unit" className="w140h48" value={this.state.selected_unit} onChange={this.unitChange}>
                                    {this.unitRender()}
                                </Select>
                            </FormControl>
                        </Grid>
                        <br />
                        <Grid item xs={12}>
                            <FormControl className={classes.margin}>
                                <InputLabel shrink id="label-gas-cost">에너지 비용(VAT 포함)</InputLabel>
                                <GasInputStyles className="w180" id="input-gas-cost" type="number" value={this.state.inputed_cost} onChange={this.costInput}/>
                            </FormControl>
                            <FormControl className={classes.margin}>
                                <InputLabel shrink id="label-gas-cost-unit">에너지 비용 단위</InputLabel>
                                <Select labelId="gas-cost-unit" id="select-gas-cost-unit" className="w140h48" value={this.state.selected_cost} onChange={this.costChange}>
                                    {this.costRender()}
                                </Select>
                            </FormControl>
                        </Grid>
                </div>
                <div className={classes.fnTitle}  align="center">
                <GasButtonStyles variant="contained" color="primary" className={classes.margin} onClick={(e) => this.onClick()}>계산하기</GasButtonStyles>
                </div>
                <GasResultComponent result_cost={this.state.result_cost} result_per={this.state.result_per} selected_cost={this.state.selected_cost}/>
            </div>
        );
    }
}

export default withStyles(GasCalculatorStyles)(GasCostCalculator);